import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const ADMIN_TOKEN_KEY = "jayink_admin_token";
export const getAdminToken = () => localStorage.getItem(ADMIN_TOKEN_KEY) || "";
export const setAdminToken = (t) => localStorage.setItem(ADMIN_TOKEN_KEY, t);
export const clearAdminToken = () => localStorage.removeItem(ADMIN_TOKEN_KEY);

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// Attach admin token on every request (backend ignores it on public routes)
api.interceptors.request.use((config) => {
  const t = getAdminToken();
  if (t) config.headers["X-Admin-Token"] = t;
  return config;
});

export async function adminLogin(password) {
  // Verify against backend, then store on success
  const { data } = await axios.post(
    `${API}/admin/login`,
    { password },
    { headers: { "Content-Type": "application/json" } }
  );
  if (data?.ok) setAdminToken(password);
  return data;
}

export async function createBooking(payload) {
  const { data } = await api.post("/bookings", payload);
  return data;
}

export async function listBookings() {
  const { data } = await api.get("/bookings");
  return data;
}

export async function getBooking(id) {
  const { data } = await api.get(`/bookings/${id}`);
  return data;
}

export async function updateBookingStatus(id, status, extra = {}) {
  const { data } = await api.patch(`/bookings/${id}`, { status, ...extra });
  return data;
}

export async function fetchEarnings(month) {
  const { data } = await api.get("/earnings", { params: month ? { month } : {} });
  return data;
}

export async function createManualBooking(payload) {
  const { data } = await api.post("/bookings/manual", payload);
  return data;
}

export async function updateBookingDetails(id, payload) {
  const { data } = await api.patch(`/bookings/${id}/details`, payload);
  return data;
}

export async function deleteBooking(id) {
  const { data } = await api.delete(`/bookings/${id}`);
  return data;
}

export async function fetchStats() {
  const { data } = await api.get("/bookings-stats");
  return data;
}

// ---------- Clients ----------
export async function listClients() {
  const { data } = await api.get("/clients");
  return data;
}

export async function getClient(email) {
  const { data } = await api.get(`/clients/${encodeURIComponent(email)}`);
  return data;
}

export const clientsExportUrl = () => `${API}/clients-export?token=${encodeURIComponent(getAdminToken())}`;

// ---------- Posts (Portfolio blog) ----------
export async function createPost(payload) {
  const { data } = await api.post("/posts", payload);
  return data;
}

export async function listPosts(params = {}) {
  const { data } = await api.get("/posts", { params });
  return data;
}

export async function deletePost(id) {
  const { data } = await api.delete(`/posts/${id}`);
  return data;
}

export async function updatePost(id, payload) {
  const { data } = await api.patch(`/posts/${id}`, payload);
  return data;
}

export async function fetchPostsStats() {
  const { data } = await api.get("/posts-stats");
  return data;
}
